export const LayerFieldInfoService = Symbol('LayerFieldInfoService');
